const SEARCH_STATIC_UPDATED = (context, staticSearches) => {
  context.staticSearches = staticSearches;
};

const FAVORITE_SEARCH_STATIC_UPDATED = (context, favoriteStaticSearches) => {
  context.favoriteStaticSearches = favoriteStaticSearches;
};

const SET_ACTIVE_WORK_COLLAPSE_PANELS = (context, arrayOfActivePanels) => {
  context.activeWorkCollapsePanels = arrayOfActivePanels;
};

const INITIALISE_STORE = (state) => {
  if (localStorage.getItem("dashboard-work-active-collapse-panels") !== null) {
    state.activeWorkCollapsePanels = JSON.parse(localStorage.getItem("dashboard-work-active-collapse-panels"));
  }
};

export default {
  SEARCH_STATIC_UPDATED,
  FAVORITE_SEARCH_STATIC_UPDATED,
  SET_ACTIVE_WORK_COLLAPSE_PANELS,
  INITIALISE_STORE,
};
